import React from 'react'
import { Card } from 'react-bootstrap'
import './Contacts.css'

export default function Contacts() {
  return (
    <div className='bg-events-col pb-4'>
    <div className='jumbotron' style={{ paddingTop: '120px' }}>
        <h2 className='text-center'>
          Contact <span style={{color:"#7E014D"}}>Us</span>
          </h2>
    </div>
    <div className='container-fluid'>
    <h4 className='text-center'>
    <span style={{color:"#4285F4"}} >G</span>
<span style={{color:"#EA4335"}}>o</span>
<span style={{color:"#FBBC05"}}>o</span>
<span style={{color:"#4285F4"}}>g</span>
<span style={{color:"#34A853"}}>l</span>
<span style={{color:"#EA4335"}}>e </span>
         Map To Reach Us</h4><br/>
    <div className='conainer-fluid row' style={{paddingBottom: 100}}>
        <div className='col-1'></div>
        <div className='col-10'>
        <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3597.4826250731776!2d85.05401359999999!3d25.622102899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed57bd196b078f%3A0xdca81888026f4000!2sMadhu%20Villa!5e0!3m2!1sen!2sin!4v1708439678399!5m2!1sen!2sin"
      width="100%"
      height="700"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
        </div>
        <div className='col-1'></div>
   
    </div>
    
    <div  className='container-fluid'>
      <h2 className='text-center fw-bold mb-4'>
        CONTACT <span style={{ color: "#7E014D" }}>DETAILS</span>
      </h2>
      <div className='row justify-content-center'>
        <div className='col-12 col-md-8 col-lg-6'>
          <div className="card shadow-lg border-0 p-4 mb-5">
            <div className="contact-details">
              <div className="detail-item d-flex align-items-center mb-4">
                <span className="contact-icon me-3">
                  <i className="bi bi-telephone-fill"></i>
                </span>
                <div>
                  <span className='fw-bold'>Business Enquiry:</span>
                  <br />
                  <a href="tel:+918789541680" className='text-decoration-none'>
                    <span style={{ color: "#7E014D" }}>+918789541680</span>
                  </a>
                </div>
              </div>
              <div className="detail-item d-flex align-items-center mb-4">
                <span className="contact-icon me-3">
                  <i className="bi bi-envelope-at-fill"></i>
                </span>
                <div>
                  <span className='fw-bold'>Email:</span>
                  <br />
                  <a href='mailto:contact@mazeflipservices.com' className="text-decoration-none">
                    <span className='fluid-small-text' style={{ color: "#7E014D" }}>contact@mazeflipservices.com</span>
                  </a>
                </div>
              </div>
              <div className="detail-item d-flex align-items-start mb-4">
                <span className="contact-icon me-3 mt-1">
                  <i className="bi bi-geo-alt-fill"></i>
                </span>
                <div>
                  <span className='fw-bold'>Address:</span>
                  <br />
                  <span style={{ color: "#7E014D", fontSize: 18 }}>
                    Mazeflip Services, Ward No-20, Sultanpur, East Matth, PO Danapur Cantt, Patna, Bihar, PIN:801503
                  </span>
                </div>
              </div>
              <div className="detail-item d-flex align-items-center">
                <span className="contact-icon me-3">
                  <i className="bi bi-alarm-fill"></i>
                </span>
                <div>
                  <span className='fw-bold'>Timing:</span>
                  <br />
                  <span style={{ color: "#7E014D", fontSize: 18 }}>Mon to Sat (10 am to 7 pm)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .contact-details .contact-icon {
          font-size: 2rem;
          color: #7E014D;
          min-width: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .contact-details .detail-item {
          font-size: 1.1rem;
        }
        @media (max-width: 767.98px) {
          .contact-details .contact-icon {
            font-size: 1.5rem;
            min-width: 2rem;
          }
          .card.p-4 {
            padding: 1.2rem !important;
          }
        }
      `}</style>
    </div>
   
    </div>
      
    </div>
  )
}
